import type { NovelSilhouette } from './types';

export function Silhouette({
  kind,
  label,
}: {
  kind: NovelSilhouette;
  label?: string;
}) {
  const path =
    kind === 'female_01'
      ? 'M60 28c8 0 14 7 14 16s-6 16-14 16-14-7-14-16 6-16 14-16zm0 36c18 0 32 10 34 28H26c2-18 16-28 34-28z'
      : 'M60 26c9 0 15 8 15 18s-6 18-15 18-15-8-15-18 6-18 15-18zm0 40c20 0 34 12 36 30H24c2-18 16-30 36-30z';

  return (
    <div className="flex flex-col items-center" aria-hidden={!label}>
      <svg viewBox="0 0 120 120" className="h-36 w-28 text-black/70 sm:h-44 sm:w-32" role="img">
        {label ? <title>{label}</title> : null}
        <path d={path} fill="currentColor" opacity="0.85" />
      </svg>
      {label ? <span className="mt-1 max-w-[7rem] truncate text-center text-[0.65rem] text-slate-300">{label}</span> : null}
    </div>
  );
}
